import { Phone, MapPin, Clock, Instagram, Facebook } from 'lucide-react';
import { branch } from '../../mock';
import { useLang } from '../../i18n/LanguageContext';
import { LanguageSwitcher } from './LanguageSwitcher';
import { LOGO, navLinks, scrollToId, CALL_TEL, PHONE_DISPLAY, INSTAGRAM, FACEBOOK } from './constants';

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 pt-14 pb-8 bg-ink">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-3">
            <img src={LOGO} alt="The Real Turkish Barber Bray logo" className="h-12 w-auto" />
          </div>
          <p className="font-serif text-gold font-bold leading-tight">THE REAL TURKISH BARBER</p>
          <p className="text-sm text-white/50 mt-1">{t.footer.tagline}</p>
          <div className="flex items-center gap-4 mt-4">
            <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-gold transition-colors" data-testid="footer-instagram" aria-label="Instagram">
              <Instagram size={20} />
            </a>
            <a href={FACEBOOK} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-gold transition-colors" data-testid="footer-facebook" aria-label="Facebook">
              <Facebook size={20} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-gold mb-4">{t.footer.quickLinks}</h4>
          <ul className="space-y-2.5">
            {navLinks.map((l) => (
              <li key={l.id}>
                <button onClick={() => scrollToId(l.id)} className="text-sm text-white/60 hover:text-gold transition-colors" data-testid={`footer-link-${l.id}`}>
                  {t.nav[l.key]}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-gold mb-4">{t.footer.contact}</h4>
          <a href={CALL_TEL} className="flex items-center gap-2 text-sm text-white/60 hover:text-gold transition-colors mb-3" data-testid="footer-call-button">
            <Phone size={15} className="text-gold shrink-0" /> {PHONE_DISPLAY}
          </a>
          <div className="flex items-start gap-2 text-sm text-white/60">
            <MapPin size={15} className="text-gold shrink-0 mt-0.5" /> {branch.address}
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-gold mb-4">{t.footer.hours}</h4>
          <div className="flex items-start gap-2 text-sm text-white/60">
            <Clock size={15} className="text-gold shrink-0 mt-0.5" />
            <div>
              <p>{t.findUs.weekday}</p>
              <p>{t.findUs.sunday}</p>
            </div>
          </div>
          <div className="mt-5">
            <p className="text-xs uppercase tracking-widest text-gold mb-2">{t.footer.language}</p>
            <LanguageSwitcher />
          </div>
        </div>
      </div>
      <p className="text-center text-xs text-white/40 mt-12">
        © 2025 The Real Turkish Barber — Bray. {t.footer.rights}
      </p>
    </footer>
  );
};
